import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import MarketingNav from './MarketingNav';
import { PageSection } from '@gik/ui';
import { UIGradient } from '@gik/ui/types';

interface MarketingNavSectionProps {
  variant?: UIGradient;
}

export default function MarketingNavSection({ variant = 'neutral' }: MarketingNavSectionProps): React.ReactElement {
  const bem = bemBlock('marketing-nav-hero');
  return (
    <PageSection variant={variant} className={bem()}>
      <MarketingNav />
    </PageSection>
  );
}
